import { create_card_remove, query_card_remove_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model2/mjstore/mjstore-cardremove-config';

import { reactive } from 'vue';

export default () => {
  const None = null;
  const True = true;
  const False = false;

  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'input',
        name: 'order_code',
        label: '撤卡号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写撤卡流水号',
      },
      {
        type: 'remotemodal',
        name: 'card_id',
        label: '卡',
        disabled: false,
        placeholder: '请选择卡',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-card',
      },
      {
        type: 'remotemodal',
        name: 'customer_id',
        label: '会员姓名',
        disabled: false,
        placeholder: '请选择会员姓名',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-customer',
      },
      {
        type: 'remotemodal',
        name: 'staff_id',
        label: '执行人',
        disabled: false,
        placeholder: '请选择执行人',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        init_model: { shop_id: current_shop?.id },
        modalType: 'mjstore-staff',
      },
      {
        type: 'remoteselect',
        name: 'cxzc_id',
        label: '促销政策',
        disabled: false,
        placeholder: '请选择促销政策',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-policy',
      },
      // {
      //   type: 'remoteselect',
      //   name: 'shop_id',
      //   label: '执行门店',
      //   disabled: false,
      //   placeholder: '请选择执行门店',
      //   datasourceType: 'remote',
      //   mode: 'default',
      //   allowClear: true,
      //   modalType: 'mjstore-shop',
      // },
      {
        type: 'rangepicker',
        name: 'date_interval',
        label: '撤卡日期',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        format: 'YYYY-MM-DD',
        valueFormat: 'YYYY-MM-DD',
        showTime: false,
        placeholder: '请选择撤卡日期',
      },
      {
        type: 'remotemodal',
        name: 'delete_staff_id',
        label: '作废执行人',
        disabled: false,
        placeholder: '请选择作废执行人',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-staff',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      order_code: null,
      card_id: null,
      customer_id: null,
      staff_id: null,
      set_record_id: null,
      cxzc_id: null,
      shop_id: current_shop?.id,
      is_delete: false,
      delete_staff_id: null,
    }),
  };
  const search_options = {
    is_delete: [
      { value: None, name: '全部' },
      { value: True, name: '已作废' },
      { value: False, name: '未作废' },
    ],
  };

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {
      customer_id: [{ required: true, message: '请填输入会员姓名' }],
      card_id: [{ required: true, message: '请填输入卡' }],
      shop_id: [{ required: true, message: '请填输入执行门店' }],
    },
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      order_code: null,
      customer_id: null,
      card_id: null,
      num: null,
      single_price: null,
      price: null,
      czje: null,
      flje: null,
      zjfl: null,
      zjje: null,
      date: null,
      shop_id: null,
      staff_id: null,
    }),
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '撤卡记录管理',
    addModalTitle: '新建撤卡记录',
    updateTitle: '修改撤卡记录',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
      slots: { customRender: 'index' },
    },
    {
      title: '撤卡日期',
      width: 150,
      dataIndex: 'date',
      checked: true,
      slots: { customRender: 'datetime' },
    },
    {
      title: '创建日期',
      width: 150,
      dataIndex: 'create_time',
      checked: true,
      slots: { customRender: 'datetime' },
    },
    {
      title: '项目类别',
      width: 100,
      dataIndex: 'card__project_type__name',
      checked: true,
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '生美项目', value: '生美项目' },
        { text: '医美项目', value: '医美项目' },
        { text: '养发项目', value: '养发项目' },
        { text: '康养项目', value: '康养项目' },
      ],
    },
    {
      title: '卡名称',
      width: 150,
      dataIndex: 'card__name',
      checked: true,
    },
    {
      title: '撤卡次数',
      width: 75,
      dataIndex: 'num',
      checked: true,
    },
    {
      title: '项目单价',
      width: 75,
      dataIndex: 'single_price',
      checked: true,
      slots: { customRender: 'round_price' },
    },
    {
      title: '撤卡金额',
      width: 75,
      dataIndex: 'price',
      checked: true,
      slots: { customRender: 'round_price' },
    },
    {
      title: '充值使用金额',
      width: 110,
      dataIndex: 'czje',
      checked: true,
      slots: { customRender: 'round_price' },
    },
    {
      title: '返利使用金额',
      width: 110,
      dataIndex: 'flje',
      checked: true,
      slots: { customRender: 'round_price' },
    },
    {
      title: '直接返利',
      width: 110,
      dataIndex: 'zjfl',
      checked: true,
      slots: { customRender: 'round_price' },
    },
    {
      title: '赠券使用金额',
      width: 110,
      dataIndex: 'zjje',
      checked: true,
      slots: { customRender: 'round_price' },
    },

    {
      title: '促销政策',
      width: 110,
      dataIndex: 'card_record__cxzc__name',
      checked: true,
    },
    {
      title: '撤卡原因',
      width: 300,
      dataIndex: 'reason',
      checked: true,
    },
    {
      title: '撤卡号',
      width: 180,
      dataIndex: 'order_code',
      checked: true,
    },
    {
      title: '卡号',
      width: 180,
      dataIndex: 'card_record__order_code',
      checked: true,
    },
    {
      title: '诉求号',
      width: 170,
      dataIndex: 'require_info__code',
      checked: true,
    },
    // {
    //   title: '会籍门店',
    //   width: 110,
    //   dataIndex: 'customer__shop__name',
    //   checked: true,
    // },
    // {
    //   title: '会员编号',
    //   width: 150,
    //   dataIndex: 'customer__code',
    //   checked: true,
    // },
    // {
    //   title: '会员姓名',
    //   width: 110,
    //   dataIndex: 'customer__name',
    //   checked: true,
    // },
    // {
    //   title: '备注',
    //   width: 200,
    //   dataIndex: 'mark',
    //   checked: true,
    // },
    {
      title: '所属顾问',
      width: 150,
      dataIndex: 'customer__adviser__name',
      checked: true,
    },
    {
      title: '执行门店',
      width: 75,
      dataIndex: 'shop__name',
      checked: true,
    },
    {
      title: '执行人',
      width: 75,
      dataIndex: 'staff__name',
      checked: true,
    },
    {
      title: '单据状态',
      width: 150,
      dataIndex: 'is_delete',
      checked: true,
      slots: { customRender: 'is_delete' },
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '已作废', value: true },
        { text: '未作废', value: false },
      ],
    },
    // {
    //   title: '确认日期',
    //   width: 135,
    //   dataIndex: 'receipt_datetime',
    //   checked: true,
    //   slots: { customRender: 'datetime' },
    // },
    {
      title: '操作',
      width: 160,
      dataIndex: 'action',
      checked: true,
      slots: { customRender: 'action' },
      fixed: 'right',
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push({
    type: 'custom',
    slotName: 'is_delete',
    field_true: '已作废',
    field_false: '未作废',
  });

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_card_remove_list,
    addData: create_card_remove,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
